import React, {useMemo, useState} from 'react';
import {Button, Layout, Typography, Input, message, Progress, Checkbox} from "antd";
import {LeftOutlined, RightOutlined} from "@ant-design/icons";
import ModelViewerTile from "./ModelViewerTile";
import {track} from "@amplitude/analytics-browser";
import axios from "axios";
import {GLOBAL_CONFIG} from "../../tools/global_config";
import {useAuthState} from "react-firebase-hooks/auth";
import {auth} from "../../tools/firebase";
const { Title, Text } = Typography;

const { TextArea } = Input;

const TextureDescription = ({path, onBackTap, onGenerateTap, generating, progress, isVolumetric, isForRaf, rotation, camera}) => {

    const [user, loading, error] = useAuthState(auth);

    const [prompt, setPrompt] = useState("");
    const [token, setToken] = useState("");
    const [useMaterial, setUseMaterial] = useState(true);

    const onCheckboxChanged = (e) => {
        setUseMaterial(e.target.checked);
    };

    const modelTile = useMemo(() => {
        return <ModelViewerTile
            width={"40rem"}
            height={"40rem"}
            glbPath={path}
            rotation={isVolumetric ? [Math.PI / 2, Math.PI, 0] : rotation}
            camera={isVolumetric ? { position: [-1, 20, 20], fov: 10 } : camera}
        />;
    }, [path]);

    return (

        <div style={{backgroundColor: "black", height: "90vh"}}>
            <Layout>
                {
                    isVolumetric || isForRaf ?
                        <Title
                            level={1}
                            style={{color: "white", fontFamily: "Avenir", textAlign: "center", marginTop: "2rem"}}
                        >
                            Enter a text prompt to texture the asset
                        </Title>
                        :
                        <div className="flex justify-between" style={{marginTop: "5em", marginLeft: "4em", marginRight: "4em"}}>
                            <Button
                                type="text"
                                icon={<LeftOutlined />}
                                style={{width: 48, height: 48}}
                                onClick={onBackTap}
                            />
                            <Title
                                level={1}
                                style={{color: "white", fontFamily: "Avenir"}}
                            >
                                Enter a text prompt to texture the asset
                            </Title>
                            <div/>
                        </div>
                }
                <div style={{display: "flex", marginLeft: "4rem", marginTop: "4rem", justifyContent: "center", flexDirection: "row-reverse"}}>
                    <div style={{
                        backgroundColor: "#313131",
                        width: "50rem",
                        height: "40rem",
                        transform: "translateX(-3rem)",
                        borderRadius: 32
                    }}>
                        <div className="flex flex-col gap-2 justify-center" style={{marginLeft: "5rem", height: "100%", marginRight: "5rem", fontFamily: "Avenir"}}>
                            <Title
                                level={2}
                                className="text-white font-medium text-left"
                            >
                                Texture description
                            </Title>
                            <p className="text-gray-400 font-medium text-left text-base">
                                Type in a description of desired result.<br/>
                                For example "{isVolumetric ? "Golden chest" : "Magical axe with green runes"}"
                            </p>
                            <TextArea
                                rows={4}
                                placeholder={"Your description"}
                                style={{textColor: "black", fontSize: 18}}
                                allowClear={true}
                                autoSize={true}
                                prefix={<RightOutlined/>}
                                onChange={(e) => {
                                    setPrompt(e.target.value)
                                }}
                            />
                            <div className="flex justify-start gap-4" style={{marginTop: "2rem"}}>
                                <Button
                                    type="primary"
                                    shape="round"
                                    loading={generating}
                                    disabled={prompt.length === 0}
                                    style={{fontFamily: "Avenir", width: "12rem", height: "3rem", fontSize: 18}}
                                    onClick={() => onGenerateTap(prompt)}
                                >
                                    Generate
                                </Button>
                            </div>
                            {
                                generating ?
                                    <Progress percent={Math.round(progress * 100)} style={{marginTop: "2rem"}}/>
                                    : <div/>
                            }
                        </div>
                    </div>
                    {modelTile}
                </div>
            </Layout>
        </div>
    );
};

export default TextureDescription;